const initialState = {
  data: null,
  loading: false,
  error: null
};

const shabbatReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_SHABBAT_START':
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case 'FETCH_SHABBAT_SUCCESS':
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    
    case 'FETCH_SHABBAT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default shabbatReducer;